import { useContext, useState } from 'react';
import { TextField as MdTextField, Grid, Button, FormControlLabel, Checkbox } from '@mui/material';
import { MdBusiness as SimecUserIcon, MdPersonOutline as CustomerUserIcon } from 'react-icons/md';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { Autocomplete } from '@mui/material';
import { useSnackbar } from 'notistack';


const ManagePeople = () => {
    let { enqueueSnackbar } = useSnackbar();
    let { formatMessage } = useIntl();

    let service = useContext(ticketDetailsContext);

    let [watcher, setWatcher] = useState<string>('');
    let [receiveNotifications, setReceiveNotifications] = useState<boolean>(true);


    return (
        <>
            <Grid item xs md={4}>
                <Autocomplete
                    value={watcher}
                    onChange={(e, newValue) => setWatcher(newValue || '')}
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => service.watcherUsers.getValueByKey(option, 'email', 'name')}
                    renderOption={(muiProps, option) => (
                        <li {...muiProps}>
                            {service.watcherUsers.getValueByKey(option, 'email', 'isExternal') === true && <CustomerUserIcon />}
                            {service.watcherUsers.getValueByKey(option, 'email', 'isExternal') === false && <SimecUserIcon />}
                            {<>&nbsp;{service.watcherUsers.getValueByKey(option, 'email', 'name')}</>}
                        </li>
                    )}
                    options={service.watcherUsers.map(x => x.email)}
                    renderInput={(params) =>
                        <MdTextField
                            {...params}
                            label={formatMessage({ id: LocalizationIds.AddUser })}
                        />
                    }
                />
            </Grid>
            <Grid item>
                <FormControlLabel
                    label={formatMessage({ id: LocalizationIds.ReceiveNotifications })}
                    name="showEmpty"
                    control={<Checkbox
                        checked={receiveNotifications}
                        onChange={(e, value) => setReceiveNotifications(e.target.checked)}
                        color="secondary"
                    />}
                />
            </Grid>
            <Grid item>
                <Button
                    variant="outlined"
                    onClick={async () => {
                        if (!watcher || watcher === '') {
                            enqueueSnackbar("Utente non selezionato", { variant: 'error' })
                            return;
                        }

                        await service.addWatcher(watcher, receiveNotifications);
                        setWatcher('');
                        setReceiveNotifications(true);
                    }}
                >
                    {formatMessage({ id: LocalizationIds.Confirm })}
                </Button>
            </Grid>
        </>
    )
}

export default ManagePeople;